import {AxiosError} from 'axios';
import {useMutation} from '@tanstack/react-query';

import {api} from '@eksab/api';

import {useGroupQuery, useSetGroupQueryData} from './';

type JoinParams =
  | {
      entry_code?: string;
    }
  | undefined;

export function useJoinGroupMutation(groupId: string | number) {
  const groupQuery = useGroupQuery(groupId);
  const setGroupQueryData = useSetGroupQueryData();

  return useMutation<unknown, AxiosError, JoinParams>((params) => api.post(`v2/groups/join/${groupId}`, params), {
    onSuccess: () => setGroupQueryData(`${groupId}`, {joined: true, member_count: groupQuery.data!.member_count + 1}),
  });
}
